<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <!--<segments></segments>-->
          <organization-chart></organization-chart>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Segments from './Segments/Segments.vue'
  import OrganizationChart from './OrganizationChart/OrganizationChart.vue'

  export default {
    components: {
      Segments,
      OrganizationChart
    }
  }

</script>
<style>

</style>
